
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotions/get-on-the-road-with-deliveroo-download",
      function () {
        return require("private-next-pages/promotions/get-on-the-road-with-deliveroo-download.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotions/get-on-the-road-with-deliveroo-download"])
      });
    }
  